


const M_Nav_reducer=(state ="close", action)=>{
  switch (action.type) {
    case "open":
      return "open";
    case "close":
      return "close";
    default:
      return state;
  }
}

export default M_Nav_reducer; 